var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.totalCount
    ? _c("div", [
        _c(
          "a",
          {
            staticClass: "inline-link footer-selected",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.scrollTo("#products-search-selected")
              }
            }
          },
          [
            _c("b", [
              _c("i", [
                _vm._v(_vm._s(_vm.$tc("Selected {$n} product", _vm.totalCount)))
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }